module.exports = __webpack_public_path__ + "static/media/AlpsLogiclogo.38829cb9.png";